import axios from 'axios';

export default {
    productLabelDetailsSmallWindow(productId) {
        return axios.post('/label/productLabelDetailsSmallWindow/', {
            productId,
        });
    },
    productLabelDetails(employeeId, productId) {
        return axios.post('/label/productLabelDetails/', {
            employeeId,
            productId,
        });
    },
    listProductTypeLabels(productId) {
        return axios.post('/label/listProducttypeLabels/', { productId });
    },
};
